module.exports = __webpack_public_path__ + "static/media/mobile-hori.dc27a9a4.png";